import { arrayToPickyDict, Dict, dictToKeyValueItems, includes } from '@nk/utils-lib';

export const COLUMN_FEATURE_MAPPING = {
  company_share_issue_enterprise_value: 'enterprise_value',
  company_share_issue_enterprise_value_latest: 'enterprise_value',
  company_share_issue_enterprise_value_history: 'enterprise_value',
};

// prettier-ignore
export const SELECTABLE_COLUMNS = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'company.name': 'company',
  'company.org_nr_schema': 'company',
  'company.org_nr': 'company',
  'company_description_purpose_latest.description': 'company',
  'company_description_purpose_latest.from_date': 'company',
  'company_nace_code_aggregate.nace_code_uuids': 'company',
  'company_details.establishment_date': 'company',
  'company_details.sector_code': 'company',
  'person_company_role_board_chairman_aggregate_latest.person_company_role_composites': 'roles',
  'person_company_role_ceo_aggregate_latest.person_company_role_composites': 'roles',
  'company_affiliation_aggregate_auditors.affiliated_entity_name': 'company_affiliation',
  'company_affiliation_aggregate_accountants.affiliated_entity_name': 'company_affiliation',
  'company_details.phone_number': 'contact',
  'company_details.website_url': 'contact',
  // Emails for companies for Norway are deprecated
  // We do not have this as an updated datapoint, and haven't had it for more than 6 years.
  // There are emails for other countries, but we need to hide it first and foremost,
  // also later we can look at having variable options on land
  // See linear task E-802.
  // 'company_details.email': 'contact',
  'company_details.employees': 'company_health',
  'company_flag_history_aggregate.company_flag_type_uuids': 'company_health',
  'company_risk_score_official_prioritized_latest.company_risk_score_measure_value': 'company_health',
  'company_details.bankrupt_flag': 'company_health',
  'company_details.under_liquidation_flag': 'company_health',
  'company_details.under_forced_liquidation_flag': 'company_health',
  'company_location.geo_subdivision_uuid': 'location',
  'company_location.geo_municipality_uuid': 'location',
  'company_location.geo_postal_code_uuid': 'location',
  'company_location.postal_place': 'location',
  'company_location.geo_country_uuid': 'location',
  'company_location.street_address': 'location',
  'postal_address.geo_subdivision_uuid': 'postal_address',
  'postal_address.geo_municipality_uuid': 'postal_address',
  'postal_address.geo_postal_code_uuid': 'postal_address',
  'postal_address.postal_place': 'postal_address',
  'postal_address.geo_country_uuid': 'postal_address',
  'postal_address.street_address': 'postal_address',
  'accounts_highlights.accounting_year': 'accounts_highlights',
  'accounts_highlights.income_statement__ebt': 'accounts_highlights',
  'accounts_highlights.income_statement__ebit': 'accounts_highlights',
  'accounts_highlights.income_statement__ebitda': 'accounts_highlights',
  'accounts_highlights.current_ratio': 'accounts_highlights',
  'accounts_highlights.quick_ratio': 'accounts_highlights',
  'accounts_highlights.profit_margin': 'accounts_highlights',
  'accounts_highlights.equity_profitability': 'accounts_highlights',
  'accounts_highlights.equity_ratio': 'accounts_highlights',
  'accounts_highlights.debt_ratio': 'accounts_highlights',
  'accounts_income_statement.accounting_year': 'accounts_income_statement',
  'accounts_income_statement.currency_code': 'accounts_income_statement',
  'accounts_income_statement.total_operating_income': 'accounts_income_statement',
  'accounts_income_statement.total_sales': 'accounts_income_statement',
  'accounts_income_statement.cost_of_goods_sold': 'accounts_income_statement',
  'accounts_income_statement.gross_profit': 'accounts_income_statement',
  'accounts_income_statement.personnel_expenses': 'accounts_income_statement',
  'accounts_income_statement.total_operating_expenses': 'accounts_income_statement',
  'accounts_income_statement.total_fin_income': 'accounts_income_statement',
  'accounts_income_statement.net_income': 'accounts_income_statement',
  'accounts_income_statement.dividend': 'accounts_income_statement',
  'accounts_balance_sheet.accounting_year': 'accounts_balance_sheet',
  'accounts_balance_sheet.currency_code': 'accounts_balance_sheet',
  'accounts_balance_sheet.cash_and_deposits': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_tangible_assets': 'accounts_balance_sheet',
  'accounts_balance_sheet.accounts_receivables': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_short_term_investments': 'accounts_balance_sheet',
  'accounts_balance_sheet.fixed_fin_assets': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_fixed_assets': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_long_term_debt': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_assets': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_current_assets': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_current_debt': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_equity': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_liabilities': 'accounts_balance_sheet',
  'accounts_balance_sheet.total_equity_and_liabilities': 'accounts_balance_sheet',
  'company_collateral_aggregate.collateral_count': 'collateral',
  'company_collateral_aggregate.collateral_amount': 'collateral',
  'company_collateral_aggregate.company_collateral_creditor_uuids': 'collateral',
  'company_collateral_aggregate.company_collateral_type_uuids': 'collateral',
  'watchlist_mapping_aggregate.watchlist_uuids': 'watchlist',
  'watchlist_mapping_aggregate.watchlist_names': 'watchlist',
  'watchlist_mapping_aggregate.added_timestamp': 'watchlist',
  'mention_search_aggregate.mention_search_count': 'mention_search',
  'mention_search_aggregate.mention_search_text': 'mention_search',
  'organization_type.organization_type_code': 'organization_type',
  'organization_type.organization_type_description': 'organization_type',
  'company_share_issue_enterprise_value.to_ownership_year': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.change_total_equity_from_shareholder': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.change_share_count': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.to_share_count': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.market_capitalization': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.enterprise_value': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.pe_ratio': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.ev_ebitda_ratio': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.ev_revenue_ratio': 'company_share_issue_enterprise_value',
  'company_share_issue_enterprise_value.to_shareholder_count': 'company_share_issue_enterprise_value',
  /* eslint-enable */
} as const;

export type SelectableColumn = keyof typeof SELECTABLE_COLUMNS;

function populateSelectableColumns(
  selectableColumns: Dict<string>,
  applyFieldGroupPostfixes: string[],
  onlyOnFieldGroupPrefix: string,
): void {
  const selectableColumnsCopy = { ...selectableColumns };
  for (const postfix of applyFieldGroupPostfixes) {
    for (const item of dictToKeyValueItems(selectableColumnsCopy)) {
      if (item.key.startsWith(onlyOnFieldGroupPrefix)) {
        let fieldGroup: string;
        let fieldName: string;
        const value = `${item.value}${postfix}`;
        if (includes(item.key, '.')) {
          [fieldGroup, fieldName] = item.key.split('.');
          selectableColumns[`${fieldGroup}${postfix}.${fieldName}`] = value;
        } else {
          fieldGroup = item.key;
          selectableColumns[`${fieldGroup}${postfix}`] = value;
        }
      }
    }
  }
}

populateSelectableColumns(SELECTABLE_COLUMNS, ['_latest', '_history'], 'accounts_');
populateSelectableColumns(SELECTABLE_COLUMNS, ['_latest', '_history'], 'company_share_');

export const FILTERABLE_COLUMNS = {
  accounts_highlights: true,
  accounts_income_statement: true,
  accounts_balance_sheet: true,
  company_share_issue_enterprise_value: true,
  accounts_highlights_latest: true,
  accounts_income_statement_latest: true,
  accounts_balance_sheet_latest: true,
  company_share_issue_enterprise_value_latest: true,
  accounts_highlights_history: false,
  accounts_income_statement_history: false,
  accounts_balance_sheet_history: false,
  company_share_issue_enterprise_value_history: false,
};

export const FIELD_GROUP_TO_TRANSLATION_OVERRIDES = {
  accounts_highlights: 'accounts.highlights',
  accounts_income_statement: 'accounts.income_statement',
  accounts_balance_sheet: 'accounts.balance_sheet',
  accounts_highlights_latest: 'accounts.highlights',
  accounts_income_statement_latest: 'accounts.income_statement',
  accounts_balance_sheet_latest: 'accounts.balance_sheet',
  accounts_highlights_history: 'accounts.highlights',
  accounts_income_statement_history: 'accounts.income_statement',
  accounts_balance_sheet_history: 'accounts.balance_sheet',
};

// prettier-ignore
export const DEFAULT_SELECTED_COLUMNS = [
  'company_flag_history_aggregate.company_flag_type_uuids',
  'company_risk_score_official_prioritized_latest.company_risk_score_measure_value',
  'accounts_highlights_latest.income_statement__ebitda',
  'accounts_highlights_latest.profit_margin',
  'accounts_income_statement_latest.total_operating_income',
  'accounts_balance_sheet_latest.total_equity',
];

export const DEFAULT_FILTER = [];

// prettier-ignore
export const SORTABLE_COLUMNS = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'company.name': true,
  'company_risk_score_official_prioritized_latest.company_risk_score_measure_value': true,
  'company_details.employees': true,
  'company_description_purpose_latest.from_date': true,
  'company_details.establishment_date': true,
  'accounts_highlights': true,
  'accounts_income_statement': true,
  'accounts_balance_sheet': true,
  'accounts_highlights_latest': true,
  'accounts_income_statement_latest': true,
  'accounts_balance_sheet_latest': true,
  'company_collateral_aggregate.collateral_count': true,
  'company_collateral_aggregate.collateral_amount': true,
  'mention_search_aggregate.mention_search_count': true,
  'company_share_issue_enterprise_value': true,
  'company_share_issue_enterprise_value_latest': true,
  'company_affiliation_aggregate_auditors.affiliated_entity_name': true,
  'company_affiliation_aggregate_accountants.affiliated_entity_name': true,
  /* eslint-enable */
};

export const DEFAULT_REQUIRED_COLUMNS = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'company.name': true,
  /* eslint-enable */
};

// prettier-ignore
export const FIELD_TYPES = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'accounts_highlights': 'thousand',
  'accounts_highlights.currency_code': 'text',
  'accounts_highlights_latest.currency_code': 'text',
  'accounts_highlights_history.currency_code': 'text',
  'accounts_highlights.accounting_year': 'text',
  'accounts_highlights.current_ratio': 'percent',
  'accounts_highlights.quick_ratio': 'percent',
  'accounts_highlights.profit_margin': 'percent',
  'accounts_highlights.equity_profitability': 'percent',
  'accounts_highlights.equity_ratio': 'percent',
  'accounts_highlights.debt_ratio': 'percent',
  'accounts_highlights_latest': 'thousand',
  'accounts_highlights_latest.accounting_year': 'text',
  'accounts_highlights_latest.current_ratio': 'percent',
  'accounts_highlights_latest.quick_ratio': 'percent',
  'accounts_highlights_latest.profit_margin': 'percent',
  'accounts_highlights_latest.equity_profitability': 'percent',
  'accounts_highlights_latest.equity_ratio': 'percent',
  'accounts_highlights_latest.debt_ratio': 'percent',
  'accounts_highlights_history': 'thousand',
  'accounts_highlights_history.accounting_year': 'text',
  'accounts_highlights_history.current_ratio': 'percent',
  'accounts_highlights_history.quick_ratio': 'percent',
  'accounts_highlights_history.profit_margin': 'percent',
  'accounts_highlights_history.equity_profitability': 'percent',
  'accounts_highlights_history.equity_ratio': 'percent',
  'accounts_highlights_history.debt_ratio': 'percent',
  'accounts_income_statement.currency_code': 'text',
  'accounts_income_statement_latest.currency_code': 'text',
  'accounts_income_statement_history.currency_code': 'text',
  'accounts_income_statement': 'thousand',
  'accounts_income_statement.accounting_year': 'text',
  'accounts_income_statement_latest': 'thousand',
  'accounts_income_statement_latest.accounting_year': 'text',
  'accounts_income_statement_history': 'thousand',
  'accounts_income_statement_history.accounting_year': 'text',
  'accounts_balance_sheet.currency_code': 'text',
  'accounts_balance_sheet_latest.currency_code': 'text',
  'accounts_balance_sheet_history.currency_code': 'text',
  'accounts_balance_sheet': 'thousand',
  'accounts_balance_sheet.accounting_year': 'text',
  'accounts_balance_sheet_latest': 'thousand',
  'accounts_balance_sheet_latest.accounting_year': 'text',
  'accounts_balance_sheet_history': 'thousand',
  'accounts_balance_sheet_history.accounting_year': 'text',
  'mention_search_aggregate.mention_search_text': 'text',
  'company_share_issue_enterprise_value.change_total_equity_from_shareholder': 'thousand',
  'company_share_issue_enterprise_value.change_share_count': 'number',
  'company_share_issue_enterprise_value.to_share_count': 'number',
  'company_share_issue_enterprise_value.enterprise_value': 'thousand',
  'company_share_issue_enterprise_value.market_capitalization': 'thousand',
  'company_share_issue_enterprise_value.to_ownership_year': 'text',
  'company_share_issue_enterprise_value.pe_ratio': 'ratio',
  'company_share_issue_enterprise_value.ev_ebitda_ratio': 'ratio',
  'company_share_issue_enterprise_value.ev_revenue_ratio': 'ratio',
  'company_share_issue_enterprise_value_latest.change_total_equity_from_shareholder': 'thousand',
  'company_share_issue_enterprise_value_latest.change_share_count': 'number',
  'company_share_issue_enterprise_value_latest.to_share_count': 'number',
  'company_share_issue_enterprise_value_latest.enterprise_value': 'thousand',
  'company_share_issue_enterprise_value_latest.market_capitalization': 'thousand',
  'company_share_issue_enterprise_value_latest.to_ownership_year': 'text',
  'company_share_issue_enterprise_value_latest.pe_ratio': 'ratio',
  'company_share_issue_enterprise_value_latest.ev_ebitda_ratio': 'ratio',
  'company_share_issue_enterprise_value_latest.ev_revenue_ratio': 'ratio',
  'company_share_issue_enterprise_value_history.change_total_equity_from_shareholder': 'thousand',
  'company_share_issue_enterprise_value_history.change_share_count': 'number',
  'company_share_issue_enterprise_value_history.to_share_count': 'number',
  'company_share_issue_enterprise_value_history.enterprise_value': 'thousand',
  'company_share_issue_enterprise_value_history.market_capitalization': 'thousand',
  'company_share_issue_enterprise_value_history.to_ownership_year': 'text',
  'company_share_issue_enterprise_value_history.pe_ratio': 'ratio',
  'company_share_issue_enterprise_value_history.ev_ebitda_ratio': 'ratio',
  'company_share_issue_enterprise_value_history.ev_revenue_ratio': 'ratio',
  'company_details.bankrupt_flag': 'boolean',
  'company_details.under_liquidation_flag': 'boolean',
  'company_details.under_forced_liquidation_flag': 'boolean',
  'company_description_purpose_latest.from_date': 'date',
  'company_details.establishment_date': 'date',
  'watchlist_mapping_aggregate.added_timestamp': 'date',
  /* eslint-enable */
};

// prettier-ignore
export const ACCOUNTS_FIELD_TYPES = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'accounts_highlights': 'single',
  'accounts_highlights.accounting_year': 'single',
  'accounts_income_statement': 'single',
  'accounts_income_statement.accounting_year': 'single',
  'accounts_balance_sheet': 'single',
  'accounts_balance_sheet.accounting_year': 'single',
  'company_share_issue_enterprise_value': 'single',
  'company_share_issue_enterprise_value.to_ownership_year': 'single',
  'accounts_highlights_latest': 'latest',
  'accounts_income_statement_latest': 'latest',
  'accounts_balance_sheet_latest': 'latest',
  'company_share_issue_enterprise_value_latest': 'latest',
  'accounts_highlights_history': 'multiple',
  'accounts_income_statement_history': 'multiple',
  'accounts_balance_sheet_history': 'multiple',
  'company_share_issue_enterprise_value_history': 'multiple',
  /* eslint-enable */
};

// prettier-ignore
export const CUSTOM_STYLE_COLUMNS = [
  'company.name',
  'company.org_nr',
  'company_flag_history_aggregate.company_flag_type_uuids',
  'company_risk_score_official_prioritized_latest.company_risk_score_measure_value',
  'company_nace_code_aggregate.nace_code_uuids',
  'company_details.organization_type_description',
  'company_details.website_url',
  'company_details.email',
  'company_location.geo_subdivision_uuid',
  'company_location.geo_municipality_uuid',
  'company_location.geo_country_uuid',
  'company_location.geo_postal_code_uuid',
  'postal_address.geo_subdivision_uuid',
  'postal_address.geo_municipality_uuid',
  'postal_address.geo_country_uuid',
  'postal_address.geo_postal_code_uuid',
  'company_collateral_aggregate.collateral_count',
  'company_collateral_aggregate.collateral_amount',
  'company_collateral_aggregate.company_collateral_creditor_uuids',
  'company_collateral_aggregate.company_collateral_type_uuids',
  'person_company_role_board_chairman_aggregate_latest.person_company_role_composites',
  'person_company_role_ceo_aggregate_latest.person_company_role_composites',
  'watchlist_mapping_aggregate.watchlist_uuids',
  'watchlist_mapping_aggregate.watchlist_names',
  'watchlist_mapping_aggregate.added_timestamp',
  'company_details.employees',
  'company_affiliation_aggregate_auditors',
  'company_affiliation_aggregate_auditors.affiliated_entity_name',
  'company_affiliation_aggregate_accountants.affiliated_entity_name',
  'mention_search_aggregate.mention_search_text',
];

export const TO_ABBR_DICT = {
  /* eslint-disable @typescript-eslint/naming-convention */
  organization_type_description: 'org_type_desc',
  organization_type_code: 'otc',
  organization_type: 'ot',
  simple_search: 'ss',
  search_target: 'st',
  mention_search: 'ms',
  mention_search_target: 'mst',
  mention_search_type_key: 'mstk',
  mention_search_lookback_days: 'msld',
  mention_search_aggregate: 'msa',
  mention_search_count: 'msc',
  mention_search_text: 'mstxt',
  company: 'c',
  description: 'd',
  name: 'n',
  org_nr_schema: 'ons',
  org_nr: 'on',
  company_description_purpose_latest: 'cdpl',
  company_details: 'cd',
  employees: 'e',
  employee_count_from: 'ecf',
  employee_count_to: 'ect',
  business_address_place: 'bap',
  bankrupt_flag: 'bf',
  under_liquidation_flag: 'ulf',
  under_forced_liquidation_flag: 'uflq',
  accounts_highlights: 'ah',
  accounts_highlights_history: 'ahh',
  accounts_highlights_latest: 'ahl',
  income_statement__operating_revenue: 'is_or',
  income_statement__ebitda: 'is_ebitda',
  income_statement__ebit: 'is_ebit',
  income_statement__ebt: 'is_ebt',
  income_statement__ordinary_result_after_taxes: 'is_orat',
  income_statement__net_income: 'is_ni',
  balance__intangible_assets: 'b_ia',
  balance__fixed_assets: 'b_fa',
  balance__cash_and_deposits: 'b_cad',
  balance__total_current_assets: 'b_tca',
  balance__total_assets: 'b_ta',
  balance__equity: 'b_e',
  balance__liabilities: 'b_l',
  current_ratio: 'cr',
  quick_ratio: 'qr',
  return_on_assets: 'roa',
  profit_margin: 'pm',
  equity_profitability: 'ep',
  equity_ratio: 'er',
  debt_ratio: 'dr',
  income_statement__currency_code: 'is_cc',
  company_nace_code: 'cn_c',
  company_nace_code_aggregate: 'cn_ca',
  person_company_role_ceo_aggregate_latest: 'pcr_c_cl',
  person_company_role_board_chairman_aggregate_latest: 'pcr_bc_cl',
  person_company_role_composites: 'pcr_c',
  nace_code: 'nc',
  nace_code_uuid: 'nc_u',
  nace_codes: 'ncs',
  nace_code_uuids: 'nc_us',
  nace_code_mask: 'ncm',
  company_collateral: 'cc',
  company_collateral_creditor_uuid: 'cc_cr',
  company_collateral_creditor_uuids: 'cc_crs', // TODO: change company_collateral_creditor_uuids to company_collateral_creditors
  company_collateral_type_uuid: 'cc_tu',
  company_collateral_aggregate: 'cc_ag',
  company_collateral_type: 'cc_t',
  collateral_type_key: 'c_tk',
  collateral_amount: 'c_a',
  collateral_count: 'c_c',
  company_risk_score_measure: 'risk_me',
  company_risk_score_model_uuid: 'risk_mo',
  company_risk_score_official_prioritized_latest: 'crs_opl',
  company_risk_score_measure_value: 'crs_mv',
  company_risk_score_grouping_uuid: 'crs_gu',
  country_code_two: 'cou_cot',
  disabled_flag: 'dis',
  measure_timestamp: 'mea_ti',
  insert_timestamp: 'ins_ti',
  latest_measure_flag: 'la_mf',
  company_location: 'loc',
  postal_address: 'pa',
  geo_subdivision: 'geo_sub',
  geo_subdivision_uuid: 'geo_subu',
  geo_municipality: 'geo_m',
  geo_municipality_uuid: 'geo_mu',
  geo_country_uuid: 'geo_cu',
  geo_postal_code: 'geo_pc',
  geo_postal_code_uuid: 'geo_pcu',
  geo_postal_place: 'geo_pl',
  geo_country: 'geo_cou',
  geo_geometry: 'geo_g',
  uuid: 'uuid',
  subdivision_code: 'sc',
  municipality_code: 'mbk',
  establishment_date: 'ed',
  phone_number: 'pn',
  accounts: 'a',
  accounting_year: 'ay',
  watchlist_mapping_aggregate: 'wl_ag',
  watchlist: 'wl',
  added_timestamp: 'a_t',
  watchlist_uuid: 'w_uuid',
  watchlist_uuids: 'w_uuids',
  watchlist_names: 'w_names',
  company_flag_history_aggregate: 'cfh',
  company_flag_history_aggregate_and: 'cfha',
  company_flag_history_aggregate_or: 'cfho',
  company_flag_type_uuids: 'cftu',
  accounts_balance_sheet: 'abs',
  accounts_balance_sheet_history: 'absh',
  accounts_balance_sheet_latest: 'absl',
  currency_code: 'curc',
  research_and_development: 'rad',
  licenses_and_patents: 'lap',
  deferred_tax_asset: 'dta',
  goodwill: 'gw',
  total_intangible_assets: 'tia',
  land_buildings_and_other_real_estate: 'lbaore',
  machinery_and_equipment: 'mae',
  ships_rigs_planes_etc: 'srp',
  operating_movable_property_furniture_tools_etc: 'ompft',
  total_tangible_assets: 'tta',
  investments_in_subsidiaries: 'iis',
  investments_in_group_companies: 'iigc',
  loan_to_group_companies: 'ltgc',
  investments_in_associated_companies: 'iiac',
  loans_to_associated_companies: 'ltac',
  change_in_inventory_of_work_in_progress: 'ciiowip',
  equities_and_investments: 'eai',
  bonds_and_other_long_term_receivables: 'baoltr',
  pension_fund: 'pf',
  fixed_fin_assets: 'ffa',
  other_fixed_assets: 'ofa',
  total_fixed_assets: 'tfa',
  raw_materials_and_purchased_semifinished_goods: 'rmapsg',
  work_in_progress: 'wip',
  finished_goods: 'fg',
  total_inventories: 'ti',
  accounts_receivables: 'ar',
  other_short_term_receivables: 'ostr',
  accounts_receivables_group_companies: 'argc',
  payments_to_be_received_from_owners: 'ptbrfo',
  total_receivables: 'tr',
  equities_and_investments_in_group_companies: 'eaiigc',
  marketable_shares: 'marks',
  marketable_bonds: 'markb',
  other_marketable_fin_instruments: 'omfi',
  other_fin_instruments: 'ofi',
  total_short_term_investments: 'tsti',
  cash_and_deposits: 'cad',
  other_current_assets: 'oca',
  total_current_assets: 'tca',
  total_assets: 'ta',
  share_capital: 'shc',
  treasury_stock: 'ts',
  share_premium_reserve: 'spr',
  other_paid_up_equity: 'opue',
  paid_up_equity: 'pue',
  reserve_for_valuation_variations: 'rfvv',
  retained_equity: 'req',
  retained_earnings: 'rern',
  minority_interest: 'mi',
  total_equity: 'teq',
  pension_liabilities: 'pl',
  deferred_tax_assets: 'defta',
  allowances_for_liabilities: 'afl',
  total_allowances_for_liabilities: 'tafl',
  convertible_long_term_debt: 'cltb',
  debenture_loan: 'dl',
  collateral_backed_debt_to_fin_institutions: 'cbdtfi',
  long_term_debt_to_group_companies: 'ltdtgc',
  subordinated_debt: 'sd',
  misc_long_term_debt: 'mltd',
  other_long_term_debt: 'oltd',
  total_other_long_term_debt: 'taltd',
  total_long_term_debt: 'tltd',
  convertible_short_term_debt: 'cstd',
  certificate_loans: 'cl',
  debt_to_fin_institutions: 'dtfi',
  accounts_payable: 'ap',
  tax_payable: 'tp',
  value_added_taxes: 'vat',
  dividend: 'div',
  short_term_debt_to_group_companies: 'stdtgc',
  other_current_debt: 'ocd',
  total_current_debt: 'tcd',
  total_liabilities: 'tl',
  total_equity_and_liabilities: 'teal',
  overdraft: 'od',
  overdraft_limit: 'odl',
  accounts_income_statement: 'ais',
  accounts_income_statement_history: 'aish',
  accounts_income_statement_latest: 'aisl',
  total_sales: 'tots',
  other_operating_income: 'ooi',
  total_operating_income: 'toi',
  cost_of_goods_sold: 'cogs',
  inventory_change: 'ic',
  gross_profit: 'gp',
  personnel_expenses: 'pe',
  ordinary_depreciation: 'odep',
  write_downs: 'wd',
  other_operating_expenses: 'ooe',
  total_operating_expenses: 'toe',
  operating_profit: 'op',
  share_of_profit_of_subsidiaries: 'sopos',
  share_of_profit_from_group_companies: 'sopfgc',
  other_interest_income: 'oii',
  share_of_profit_from_associated_companies: 'sopfac',
  interest_income_from_group_companies: 'iifgc',
  total_other_fin_income: 'tofi',
  total_fin_income: 'tfin',
  total_other_interest_expenses: 'toie',
  write_down_of_short_term_fin_assets: 'wdostfa',
  write_down_of_other_short_term_fin_assets: 'wdoostfa',
  write_down_of_long_term_fin_assets: 'wdoltfa',
  other_fin_expenses: 'ofe',
  total_other_fin_expenses: 'tofe',
  total_fin_expenses: 'tfe',
  total_fin_items: 'tfit',
  ordinary_result_before_taxes: 'orbt',
  taxes_on_ordinary_result: 'toor',
  ordinary_result: 'or',
  extraordinary_income: 'ei',
  extraordinary_expenses: 'ee',
  total_extraordinary_items: 'tei',
  taxes_on_extraordinary_result: 'toer',
  total_taxes: 'tt',
  net_income: 'ni',
  intra_group_contribution: 'igc',
  transferred_equity: 'te',
  manager_remuneration: 'mr',
  manager_remuneration_only_salary: 'mros',
  manager_other_remuneration: 'mor',
  auditor_remuneration: 'arem',
  board_remuneration: 'brem',
  consultant_remuneration: 'crem',
  total_unaccounted_for_fin_income: 'tuffi',
  total_unaccounted_for_operating_expenses: 'tufoe',
  total_unaccounted_for_fin_expenses: 'tuffe',
  company_share_issue_enterprise_value: 'csiev',
  company_share_issue_enterprise_value_latest: 'csievl',
  company_share_issue_enterprise_value_history: 'csievh',
  to_ownership_year: 'toy',
  enterprise_value: 'ev',
  pe_ratio: 'per',
  ev_ebitda_ratio: 'evbr',
  ev_revenue_ratio: 'evrr',
  market_capitalization: 'mcap',
  to_shareholder_count: 'tshc',
  change_total_equity_from_shareholder: 'ctefsh',
  change_share_count: 'csc',
  to_share_count: 'tsc',
  company_affiliation_aggregate_auditors: 'aff_au',
  company_affiliation_aggregate_accountants: 'aff_ac',
  affiliated_entity_name: 'aff_en',
  affiliated_company_uuids: 'aff_cu',
  affiliated_person_uuids: 'aff_pu',
  /* eslint-enable */
};
export const FROM_ABBR_DICT = arrayToPickyDict(
  dictToKeyValueItems(TO_ABBR_DICT),
  (entry) => entry.value,
  (entry) => entry.key,
);
